"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

var _ref;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var scale15 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"];
var scale10 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
var LEADER_WELLBEING_ASSESMENT = "LEADER_WELLBEING_ASSESMENT";
var questions = [{
  prompt: "Firstly, how would you rate the wellbeing/mental health level of your team over the past two weeks?",
  type: "slider",
  options: scale10,
  meta: {
    summaryTitle: "Wellbeing/mental health level of your team "
  },
  batteryId: LEADER_WELLBEING_ASSESMENT
}, {
  prompt: "How many team-level conversations about wellbeing or mental health did you facilitate in the past two weeks?",
  type: "slider",
  options: scale15,
  batteryId: LEADER_WELLBEING_ASSESMENT
}, {
  prompt: "How would you rate your team-level wellbeing/mental health conversations in the past two weeks?",
  type: "slider",
  options: scale10,
  batteryId: LEADER_WELLBEING_ASSESMENT
}, {
  prompt: "Did any of the following make it hard for you to facilitate team-level wellbeing/mental health conversations in the past two weeks?",
  type: "multiWithOther",
  options: ["Lack of knowledge on how to approach", "lack of visibility around mental health problems", "lack of allocated time", "lack of resources", "lack of supervision/support", "lack of clear benefits/relevance for conversation", "lack of team buy-in", "other"],
  batteryId: LEADER_WELLBEING_ASSESMENT
}, {
  prompt: "How many one-on-one conversations about wellbeing or mental health did you facilitate in the past two weeks?",
  type: "slider",
  options: scale15,
  batteryId: LEADER_WELLBEING_ASSESMENT
}, (_ref = {
  prompt: "How would you rate your one-on-one wellbeing/mental health conversations in the past two weeks?",
  type: "radio"
}, _defineProperty(_ref, "type", "slider"), _defineProperty(_ref, "options", scale10), _defineProperty(_ref, "batteryId", LEADER_WELLBEING_ASSESMENT), _ref), {
  prompt: "Did any of the following make it hard for you to facilitate one-on-one wellbeing/mental health conversations in the past two weeks?",
  type: "multiWithOther",
  options: ["Lack of knowledge on how to approach", "lack of visibility around mental health problems", "lack of allocated time", "lack of resources", "lack of supervision/support", "lack of clear benefits/relevance for conversation", "lack of team buy-in", "other"],
  batteryId: LEADER_WELLBEING_ASSESMENT
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;